/* eslint-disable import/prefer-default-export */

import { environment } from './config';
import { getAdapter, EnvType, ChannelID } from './adapters';
import { sleep } from './utils/time';
import { hideMenu } from './helper';
import SlugShare from '.';
window.showMenuEvent = null;

const adapter = getAdapter(environment);

export async function initEvents(share: SlugShare) {
  const { config, shareConfig: preShareConfig, showMenu } = share;
  const shareConfig = {
    ...preShareConfig,
    imgUrl: preShareConfig.imgUrl?.replace(/^\/\//, 'https://'),
  };

  const els = document.querySelectorAll(config.el as string) as NodeList;
  if (els.length) {
    const event = config?.options?.eventListener
      ? config.options.eventListener
      : 'click';
    for (let i = 0, len = els.length; i < len; i++) {
      if (window.showMenuEvent && typeof window.showMenuEvent === 'function') {
        els[i].removeEventListener(event as string, window.showMenuEvent);
      }
      window.showMenuEvent = () => {
        typeof showMenu === 'function' && showMenu.apply(share);
      };
      els[i].addEventListener(event as string, window.showMenuEvent);
    }
  }
  if (typeof window !== 'undefined') {
    await adapter.init();
    if (environment === EnvType.OutGame) {
      await adapter.sendTo(config, shareConfig);
    } else {
      // eslint-disable-next-line no-param-reassign
      share.shareTo = async (channelID: ChannelID) => {
        const { title, desc, url, imgUrl } = shareConfig;
        await adapter.sendTo(config, {
          channelID,
          title,
          desc,
          url,
          imgUrl,
        });
        typeof hideMenu === 'function' && hideMenu();
        await sleep(2000);
        typeof config.afterShare === 'function' && config.afterShare(channelID, true);
      };
    }
  }
}
